const SITE_ID = Number(process.env.REACT_APP_SITE_ID)
const SITE_UID = process.env.REACT_APP_SITE_UID
const SUBDOMAIN = process.env.REACT_APP_SUBDOMAIN
export { SITE_ID, SITE_UID, SUBDOMAIN };
